import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="border-t border-neutral-100">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-6">
        <Link
          to="/contact"
          data-testid="footer-contact-link"
          className="text-xs text-neutral-500 transition-colors hover:text-neutral-900"
        >
          Contact
        </Link>
        <Link
          to="/"
          data-testid="footer-virtual-store-link"
          className="text-xs text-neutral-500 transition-colors hover:text-neutral-900"
        >
          Virtual Store
        </Link>
        <Link
          to="/policies"
          data-testid="footer-policies-link"
          className="text-xs text-neutral-500 transition-colors hover:text-neutral-900"
        >
          Policies
        </Link>
      </div>
    </footer>
  );
}
